export const environment = {
  production: false,
  apiUrl: 'https://api-uat.helplinesos.org'
};
